import { Box } from "@mui/material";

import { MAP_BAR_HEIGHT, MAP_PANEL_WIDTH_THIN, MAP_PANEL_WIDTH_WIDE } from "../../mapConstants";

type GaiaMapUIOverlayProps = {
    leftPanel?: React.ReactNode;
    rightPanel?: React.ReactNode;
    rightPanelWidth?: "wide" | "thin";
    topBar?: React.ReactNode;
    bottomBar?: React.ReactNode;
    bottomRightPanel?: React.ReactNode;
};

export function GaiaMapUIOverlay({
    leftPanel,
    rightPanel,
    rightPanelWidth = "thin",
    topBar,
    bottomBar,
    bottomRightPanel,
}: GaiaMapUIOverlayProps) {
    const rightPanelWidthPixels = rightPanelWidth === "thin" ? MAP_PANEL_WIDTH_THIN : MAP_PANEL_WIDTH_WIDE;

    return (
        <Box
            sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                padding: 1,
                display: "grid",
                gridTemplateColumns: `${MAP_PANEL_WIDTH_THIN}px auto ${rightPanelWidthPixels}px`,
                gridTemplateRows: `${MAP_BAR_HEIGHT}px auto auto ${MAP_BAR_HEIGHT}px`,
                gridTemplateAreas: `
                    "leftPanel topBar rightPanel"
                    "leftPanel content rightPanel"
                    "leftPanel content ${bottomRightPanel ? `bottomRightPanel` : "rightPanel"}"
                    "bottomBar bottomBar bottomBar"
                `,
                rowGap: 2,
                // disable pointer events for the grid and its containers
                // this allows the user to interact with the map through the overlaying grid
                pointerEvents: "none",
                "& > * > *": {
                    // re-enable pointer events for the children of the containers
                    pointerEvents: "auto",
                },
            }}
        >
            {leftPanel && (
                <Box
                    sx={{
                        gridArea: "leftPanel",
                        overflow: "hidden",
                        // box shadow + overflow fix
                        margin: -0.5,
                        padding: 0.5,

                        display: "flex",
                        flexDirection: "column",
                        gap: 2,

                        marginBottom: "40px", // safety margin for bottom controls
                    }}
                >
                    {leftPanel}
                </Box>
            )}
            {topBar && (
                <Box
                    sx={{
                        gridArea: "topBar",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    {topBar}
                </Box>
            )}
            {bottomBar && (
                <Box
                    sx={{
                        gridArea: "bottomBar",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    {bottomBar}
                </Box>
            )}
            {rightPanel && (
                <Box
                    sx={{
                        gridArea: "rightPanel",
                        overflow: "auto",
                        // box shadow + overflow fix
                        margin: -0.5,
                        padding: 0.5,

                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                    }}
                >
                    {rightPanel}
                </Box>
            )}
            {bottomRightPanel && (
                <Box
                    sx={{
                        overflow: "hidden",
                        // box shadow + overflow fix
                        margin: -0.5,
                        padding: 0.5,

                        alignSelf: "end",
                        gridArea: "bottomRightPanel",
                    }}
                >
                    {bottomRightPanel}
                </Box>
            )}
        </Box>
    );
}
